export default __webpack_public_path__ + "static/cafe_36022-91c8ad59a3119ab5fa5819aade6ea6b5.png";